import {Autocomplete, DialogActions, DialogContent, TextField} from "@mui/material";
import {ApplicationDetail} from "../../../../widgets/ApplicationDetail";
import React, {useEffect, useState} from "react";
import {getCaseByIdWorker} from "../../../../services/case";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {BaseAutocomplete} from "../../../../designSystem/components/BaseAutocomplete";

const statusOptions = [
  { id: 'completed', name: '已結案' },
  { id: 'rejected', name: '不符合資格' },
  { id: 'dead', name: '已去世' },
  { id: 'noDemand', name: '評估後無需求' },
];

export const CaseDetailForm = ({
  caseId,
  userToken,
  organizations,
  assigningStatus,
  handleAccept,
  handleReject,
  handleAssign,
  onClickReportButton,
  onClickSurveyButton,
  onClickChangeStatusButton,
  onChangeStatus,
  onChangeAssigningOrganization,
  mode
}) => {
  const [caseData, setCaseData] = useState(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchCase = async () => {
    setIsLoading(true);
    try {
      const data = await getCaseByIdWorker({ token: userToken, id: caseId })
      if (data) {
        setCaseData(data);
      }
    } catch (error) {
      console.error("Error fetching case:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (caseId && userToken) {
      fetchCase();
    }
  }, [caseId, userToken]);

  if (isLoading)
    return <LoadingDialog label="載入中" />

  return (
    <React.Fragment>
      <DialogContent sx={{ p: 0 }}>
        {caseData
          ? (
            <div className={"w-full md:w-[400px] max-w-full p-4 bg-gray-100"}>
             <ApplicationDetail caseData={caseData} />
            </div>
          )
          : null
        }
      </DialogContent>
      <DialogActions>
        {mode === 'action'
          ? (
            <div className="flex p-2 w-full gap-x-4">
              <BaseAutocomplete
                label="狀態"
                options={statusOptions}
                value={assigningStatus}
                onChangeValue={(value) => {
                  onChangeStatus(value ? {id: value.id, name: value.name} : null)
                }}
              />
              <ActionButton
                onClick={onClickChangeStatusButton}
                label="變更"
                iconName="fa-bolt"
                disabled={!assigningStatus || assigningStatus.id === ''}
              />
            </div>
          )
          : null
        }
        {mode === 'accept'
          ?
          <div className="flex p-2 w-full gap-x-4">
            <ActionButton
              fullWidth
              color="success"
              onClick={handleAccept}
              label="接受收案"
              iconName="fa-clipboard-check"
            />
            <ActionButton
              fullWidth
              color="warning"
              onClick={handleReject}
              label="拒絕收案"
              iconName="fa-circle-xmark"
            />
          </div>
          : null
        }

        {mode === 'assign'
          ?
          <div className="flex p-2 w-full gap-x-4">
            <BaseAutocomplete
              label="業務組別"
              options={organizations}
              onChangeValue={(value) => {
                onChangeAssigningOrganization(value ? {id: value.id, name: value.name} : null)
              }}
            />
            <ActionButton
              onClick={handleAssign}
              label="派案"
              iconName="fa-paper-plane"
            />
          </div> : null
        }
        {mode === 'report'
          ?
          <div className="flex p-2 w-full gap-x-4">
            <ActionButton
              fullWidth
              onClick={onClickReportButton}
              label="回報結果"
              iconName="fa-flag"
            />
          </div> : null
        }

        {mode === 'survey'
          ?
          <div className="flex p-2 w-full gap-x-4">
            <ActionButton
              fullWidth
              onClick={onClickSurveyButton}
              label="填寫滿意度調查"
              iconName="fa-face-smile"
            />
          </div> : null
        }
      </DialogActions>
    </React.Fragment>
  )
}
